import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Helmet } from 'react-helmet-async';
export function PrivacyPage() {
  return <>
      <Helmet data-id="element-257">
        <title data-id="element-258">Privacy Policy - Fifth Door</title>
        <meta name="description" content="Fifth Door Privacy Policy." data-id="element-259" />
        <link rel="preconnect" href="https://fonts.googleapis.com" data-id="element-260" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" data-id="element-261" />
        <link href="https://fonts.googleapis.com/css2?family=Bungee&family=Bricolage+Grotesque:wght@400;500;600;700&family=Instrument+Sans:wght@400;500;600;700&display=swap" rel="stylesheet" data-id="element-262" />
      </Helmet>

      <main className="w-full relative isolate overflow-x-hidden min-h-screen" style={{
      backgroundColor: '#074030'
    }} data-id="element-263">
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: `
              linear-gradient(to right, rgba(255, 255, 255, 0.1) 1px, transparent 1px),
              linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 1px, transparent 1px)
            `,
        backgroundSize: '30px 30px',
        backgroundPosition: '0 0'
      }} data-id="element-264" />
        <div className="absolute inset-0 pointer-events-none -z-10" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/bonQpX7FQKEhKvnQfRNJtT/noise-background.png)',
        backgroundRepeat: 'repeat',
        backgroundSize: '200px 200px',
        opacity: 0.24
      }} data-id="element-265" />

        <div className="absolute top-8 left-8 z-20" data-id="element-266">
          <Link to="/" className="flex items-center gap-3" data-id="element-267">
            <img src="https://cdn.magicpatterns.com/uploads/8dB8M4GqHB66FgPhzt2tyW/Group_44.png" alt="Fifth Door Logo" className="h-8 w-auto object-contain brightness-0 invert" data-id="element-268" />
            <span className="text-white text-lg" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-269">
              FIFTH DOOR
            </span>
          </Link>
        </div>

        <div className="relative z-10 px-6 py-20 md:py-32 max-w-4xl mx-auto" data-id="element-270">
          <h1 className="text-[50px] md:text-[74px] mb-8 text-center" style={{
          fontFamily: 'Bungee, sans-serif',
          color: 'white',
          lineHeight: '1.1'
        }} data-id="element-271">
            PRIVACY POLICY
          </h1>
          <div className="text-white/70 leading-relaxed text-lg space-y-6" style={{
          fontFamily: "'Instrument Sans', sans-serif"
        }} data-id="element-272">
            <p className="font-bold" data-id="element-273">Last Updated: April 13, 2026</p>

            <p data-id="element-274">
              This Privacy Notice applies to the processing of personal
              information by Fifth Door, Inc. ("Fifth Door," "we," "us," or
              "our") including on our website available at
              https://fifthdoor.com/, our mobile application, and our other
              online or offline offerings that link to, or are otherwise subject
              to, this Privacy Notice (collectively, the "Services").
            </p>

            <div className="border border-white/10 rounded-xl p-6 bg-white/5 space-y-1" data-id="element-275">
              <p className="font-bold text-white mb-2" data-id="element-276">Table of Contents</p>
              <a href="#section-1" className="block text-white/70 hover:text-white transition-colors" data-id="element-277">
                1. Updates to This Privacy Notice
              </a>
              <a href="#section-2" className="block text-white/70 hover:text-white transition-colors" data-id="element-278">
                2. Personal Information We Collect
              </a>
              <a href="#section-3" className="block text-white/70 hover:text-white transition-colors" data-id="element-279">
                3. How We Use Personal Information
              </a>
              <a href="#section-4" className="block text-white/70 hover:text-white transition-colors" data-id="element-280">
                4. How We Share Personal Information
              </a>
              <a href="#section-5" className="block text-white/70 hover:text-white transition-colors" data-id="element-281">
                5. Your Privacy Choices and Rights
              </a>
              <a href="#section-6" className="block text-white/70 hover:text-white transition-colors" data-id="element-282">
                6. International Transfers of Personal Information
              </a>
              <a href="#section-7" className="block text-white/70 hover:text-white transition-colors" data-id="element-283">
                7. Retention of Personal Information
              </a>
              <a href="#section-8" className="block text-white/70 hover:text-white transition-colors" data-id="element-284">
                8. Supplemental Notice for EU/UK GDPR
              </a>
              <a href="#section-9" className="block text-white/70 hover:text-white transition-colors" data-id="element-285">
                9. Children's Personal Information
              </a>
              <a href="#section-10" className="block text-white/70 hover:text-white transition-colors" data-id="element-286">
                10. Contact Us
              </a>
            </div>

            <h2 id="section-1" className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-287">
              1. UPDATES TO THIS PRIVACY NOTICE
            </h2>

            <p data-id="element-288">
              We may update this Privacy Notice from time to time in our sole
              discretion. If we do, we'll let you know by posting the updated
              Privacy Notice on our website, and we may also send other
              communications.
            </p>

            <h2 id="section-2" className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-289">
              2. PERSONAL INFORMATION WE COLLECT
            </h2>

            <p data-id="element-290">
              We collect personal information that you provide to us, personal
              information we collect automatically when you use the Services,
              and personal information from third-party sources, as described
              below.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-291">
              Personal Information You Provide to Us Directly
            </h3>

            <p data-id="element-292">We may collect personal information that you provide to us.</p>

            <p data-id="element-293">
              <strong data-id="element-294">Account Information.</strong> We may collect personal
              information in connection with the creation or administration of
              your account. This personal information may include, but is not
              limited to, your name, profile photo, username, email address, and
              other information you store with your account.
            </p>

            <p data-id="element-295">
              <strong data-id="element-296">Purchases or Transactions.</strong> We and our service
              providers may collect personal information and details associated
              with your purchases or transactions on the Services, including
              payment information. Any payments made via our Services are
              processed by third-party payment processors. We do not directly
              collect or store any payment card information entered through our
              Services, but we may receive information associated with your
              payment card information (e.g., your billing details).
            </p>

            <p data-id="element-297">
              <strong data-id="element-298">Your Communications with Us.</strong> We, and our service
              providers, may collect the information you communicate to us, such
              as through email.
            </p>

            <p data-id="element-299">
              <strong data-id="element-300">Surveys.</strong> We may contact you to participate in
              surveys. If you decide to participate, we may collect personal
              information from you in connection with the surveys.
            </p>

            <p data-id="element-301">
              <strong data-id="element-302">Interactive Features.</strong> We and others who use our
              Services may collect personal information that you submit or make
              available through our interactive features (e.g., messaging
              features, Discord, Feedback feature, commenting functionalities,
              forums, blogs, and social media pages). Any information you
              provide using the public sharing features of the Services will be
              considered "public."
            </p>

            <p data-id="element-303">
              <strong data-id="element-304">Friends' Information.</strong> When you use the "Friends"
              feature on the Services, we collect information about your friend
              connections, including incoming and outgoing friend requests, your
              friends' list, and any referral codes or links you generate or
              use. When you generate a referral code to share with others, the
              code is associated with your account. If another user enters your
              referral code or clicks on a referral link, your username and any
              public profile information you have chosen to share may be
              disclosed to that user. Similarly, when you enter another user's
              referral code, their username and public profile information may
              be disclosed to you.
            </p>

            <p data-id="element-305">
              <strong data-id="element-306">User Content.</strong> We may collect personal information
              that you provide when you generate, store or share mini-games and
              other content such as text (in posts or communications with
              others), files, documents, graphics, images, music, software,
              audio and video. Anything (other than Feedback) that you post or
              otherwise make available through the Services is referred to as
              "User Content". When you publish a game on the Services, other
              users may view your username and interact with your game content.
              If you generate a game, you do not receive any personal
              information about users who play such games, other than publicly
              displayed usernames and game statistics.
            </p>

            <p data-id="element-307">
              <strong data-id="element-308">Sweepstakes or Contests.</strong> We may collect personal
              information you provide for any sweepstakes or contests that we
              offer. In some jurisdictions, we are required to publicly share
              information of sweepstakes and contest winners.
            </p>

            <p data-id="element-309">
              <strong data-id="element-310">Conferences, Trade Shows, and Other Events.</strong> We
              may collect personal information from individuals when we attend
              or host conferences, trade shows, and other events.
            </p>

            <p data-id="element-311">
              <strong data-id="element-312">Business Development and Strategic Partnerships.</strong>{' '}
              We may collect personal information from individuals and third
              parties to assess and pursue potential business opportunities.
            </p>

            <p data-id="element-313">
              <strong data-id="element-314">Job Applications.</strong> If you apply for a job with us,
              we will collect any personal information you provide in connection
              with your application, such as your contact information and resume
              or CV.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-315">
              Personal Information Collected Automatically
            </h3>

            <p data-id="element-316">
              We may collect personal information automatically when you use the
              Services.
            </p>

            <p data-id="element-317">
              <strong data-id="element-318">Device Information.</strong> We may collect personal
              information about your device, such as type of model and make of
              your device, your Internet protocol (IP) address, user settings,
              cookie identifiers, other unique identifiers, browser or device
              information, Internet service provider, and location information
              (including, as applicable, an approximate location derived from
              the IP address and precise geo-location information).
            </p>

            <p data-id="element-319">
              <strong data-id="element-320">Usage Information.</strong> We may collect personal
              information about your use of the Services, such as the pages that
              you visit, number of users that can play, items that you search
              for, the types of content you interact with, information about the
              links you click, the frequency and duration of your activities,
              and other information about how you use the Services.
            </p>

            <p data-id="element-321">
              <strong data-id="element-322">Cookie Notice (and Other Technologies).</strong> We, as
              well as third parties, may use cookies, pixel tags, and other
              technologies ("Technologies") to automatically collect personal
              information through your use of the Services.
            </p>

            <ul className="list-disc pl-6 space-y-2" data-id="element-323">
              <li data-id="element-324">
                <strong data-id="element-325">Cookies.</strong> Cookies are small text files stored in
                device browsers.
              </li>
              <li data-id="element-326">
                <strong data-id="element-327">Pixel Tags/Web Beacons.</strong> A pixel tag (also known
                as a web beacon) is a piece of code embedded in the Services
                that collects personal information about use of or engagement
                with the Services. The use of a pixel tag allows us to record,
                for example, that a user has visited a particular web page or
                clicked on a particular advertisement. We may also include web
                beacons in emails to understand whether messages have been
                opened, acted on, or forwarded.
              </li>
            </ul>

            <p data-id="element-328">
              See "Your Privacy Choices and Rights" below to understand your
              choices regarding these Technologies.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-329">
              Personal Information Collected from Third Parties
            </h3>

            <p data-id="element-330">
              We may collect personal information about you from third parties.
              For example, if you access the Services using a third-party
              website, application, service, products, or technology (each a
              "Third-Party Service"), we may collect personal information about
              you from that Third-Party Service that you have made available via
              your privacy settings. In addition, users of the Services may
              upload or otherwise provide personal information about others.
              Please note that if you choose to make your profile public, other
              Fifth Door users will be able to view your profile information.
              You may choose to keep your profile private through your account
              settings.
            </p>

            <h2 id="section-3" className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-331">
              3. HOW WE USE PERSONAL INFORMATION
            </h2>

            <p data-id="element-332">
              We use personal information for a variety of business purposes,
              including to provide the Services, for administrative purposes,
              and to provide you with marketing materials, as described below.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-333">
              Provide the Services
            </h3>

            <p data-id="element-334">We use personal information to provide the Services, such as:</p>

            <ul className="list-disc pl-6 space-y-2" data-id="element-335">
              <li data-id="element-336">
                Providing access to certain areas, functionalities, and features
                of the Services;
              </li>
              <li data-id="element-337">Communicating with you;</li>
              <li data-id="element-338">Answering requests;</li>
              <li data-id="element-339">
                Sharing personal information with third parties as needed to
                provide the Services; and
              </li>
              <li data-id="element-340">
                Processing your financial information and other payment methods.
              </li>
            </ul>

            <p className="text-sm italic" data-id="element-341">
              EU/UK GDPR Lawful Bases: If the EU GDPR or the UK GDPR applies to
              our processing of personal information under this section, our
              lawful bases may include performance of a contract, legitimate
              interest, consent, and/or compliance with legal obligations.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-342">
              Improve the Services and Develop New Products and Services
            </h3>

            <p data-id="element-343">
              We use personal information to improve the Services and to develop
              new products and services, such as:
            </p>

            <ul className="list-disc pl-6 space-y-2" data-id="element-344">
              <li data-id="element-345">
                Developing, training, and fine-tuning models, algorithms, and
                artificial intelligence technologies; and
              </li>
              <li data-id="element-346">Improving, upgrading, or enhancing the Services.</li>
            </ul>

            <p className="text-sm italic" data-id="element-347">
              EU/UK GDPR Lawful Bases: If the EU GDPR or the UK GDPR applies to
              our processing of personal information under this section, our
              lawful bases may include performance of a contract, legitimate
              interest, consent, and/or compliance with legal obligations.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-348">
              Operate Our Business
            </h3>

            <p data-id="element-349">We use personal information to operate our business, such as:</p>

            <ul className="list-disc pl-6 space-y-2" data-id="element-350">
              <li data-id="element-351">
                Pursuing our legitimate interests such as direct marketing,
                research and development (including marketing research), network
                and information security, and fraud prevention;
              </li>
              <li data-id="element-352">Carrying out analytics;</li>
              <li data-id="element-353">Creating de-identified and/or aggregated information;</li>
              <li data-id="element-354">
                Processing applications if you apply for a job we post on our
                Services;
              </li>
              <li data-id="element-355">Allowing you to register for events;</li>
              <li data-id="element-356">Enforcing our agreements and policies; and</li>
              <li data-id="element-357">
                Carrying out activities that are required to comply with our
                legal obligations.
              </li>
            </ul>

            <p className="text-sm italic" data-id="element-358">
              EU/UK GDPR Lawful Bases: If the EU GDPR or the UK GDPR applies to
              our processing of personal information under this section, our
              lawful bases may include performance of a contract, legitimate
              interest, consent, and/or compliance with legal obligations.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-359">Marketing</h3>

            <p data-id="element-360">
              We may use personal information in connection with our marketing
              activities including to tailor and provide you with marketing
              communications, promotions, and offers that may interest you.
            </p>

            <p className="text-sm italic" data-id="element-361">
              EU/UK GDPR Lawful Bases: If the EU GDPR or the UK GDPR applies to
              our processing of personal information under this section, our
              lawful bases may include legitimate interest and/or consent.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-362">
              With Your Consent or Direction
            </h3>

            <p data-id="element-363">
              We may use personal information: (i) for other purposes that are
              clearly disclosed to you at the time you provide the personal
              information, (ii) with your consent, or (iii) as otherwise
              directed by you.
            </p>

            <p className="text-sm italic" data-id="element-364">
              EU/UK GDPR Lawful Bases: If the EU GDPR or the UK GDPR applies to
              our processing of personal information under this section, our
              lawful bases may include performance of a contract, legitimate
              interest, and/or consent.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-365">
              Automated Decision-Making
            </h3>

            <p data-id="element-366">
              We may engage in automated decision-making, including profiling.
            </p>

            <p className="text-sm italic" data-id="element-367">
              EU/UK GDPR Lawful Bases: If the EU GDPR or the UK GDPR applies to
              our processing of personal information under this section, our
              lawful bases may include performance of a contract, legitimate
              interest, consent, and/or compliance with legal obligations.
            </p>

            <h2 id="section-4" className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-368">
              4. HOW WE SHARE PERSONAL INFORMATION
            </h2>

            <p data-id="element-369">
              We share personal information with third parties for a variety of
              business purposes, including to provide the Services, to protect
              us or others, or in connection with a major business transaction
              such as a merger, sale, or asset transfer, as described below.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-370">
              Disclosures to Provide the Services
            </h3>

            <p data-id="element-371">
              We may share any of the personal information we collect with the
              categories of third parties described below.
            </p>

            <p data-id="element-372">
              <strong data-id="element-373">Service Providers.</strong> We may share personal
              information with service providers that assist us with the
              provision of the Services. This may include, but is not limited
              to, service providers that provide us with hosting services,
              customer service, AI or machine learning services, analytics,
              marketing services, IT support, and related services. In addition,
              personal information and chat communications may be shared with
              service providers that help provide our chat features.
            </p>

            <p data-id="element-374">Some of the service providers we may use include:</p>

            <ul className="list-disc pl-6 space-y-2" data-id="element-375">
              <li data-id="element-376">
                <strong data-id="element-377">Google Analytics.</strong> For more information about
                how Google uses your personal information, please visit Google
                Analytics' Privacy Policy. To learn more about how to opt out of
                Google Analytics' use of your personal information, please click
                here.
              </li>
            </ul>

            <p data-id="element-378">
              <strong data-id="element-379">Other Users You Share or Interact With.</strong> The
              Services may allow Fifth Door users to share personal information
              or interact with other users of the Services. When you publish a
              game, other users may see your username and interact with your
              game. When you use the friends feature, your username and public
              profile information may be shared with users who accept your
              friend request, enter your referral code, or click on the referral
              link.
            </p>

            <p data-id="element-380">
              <strong data-id="element-381">Third-Party Services You Share or Interact With.</strong>{' '}
              The Services may link to or allow you to interface with, interact
              with, share information with, direct us to share information with,
              access, and/or use a Third-Party Service.
            </p>

            <p data-id="element-382">
              Any personal information shared with a Third-Party Service will be
              subject to the Third-Party Service's privacy policy. We are not
              responsible for the processing of personal information by
              Third-Party Services.
            </p>

            <p data-id="element-383">
              <strong data-id="element-384">Business Partners.</strong> We may share your personal
              information with business partners we work with to provide you
              with a product or service you have requested. We may also share
              your personal information with business partners with whom we
              jointly offer products or services.
            </p>

            <p data-id="element-385">
              Once your personal information is shared with our business
              partner, it will also be subject to our business partner's privacy
              policy. We are not responsible for the processing of personal
              information by our business partners.
            </p>

            <p data-id="element-386">
              <strong data-id="element-387">Affiliates.</strong> We may share your personal
              information with our corporate affiliates.
            </p>

            <p data-id="element-388">
              <strong data-id="element-389">Advertising Partners.</strong> We may share your personal
              information with third-party advertising partners. These
              third-party advertising partners may set Technologies on our
              Services to collect personal information regarding your activities
              and your device (e.g., IP address, cookie identifiers, page(s)
              visited, location, time of day). These advertising partners may
              use this personal information (and similar information collected
              from other services) to tailor and deliver personalized ads to you
              when you visit digital properties within their networks. This
              practice is commonly referred to as "interest-based advertising,"
              "personalized advertising," or "targeted advertising."
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-390">
              Disclosures to Protect Us or Others
            </h3>

            <p data-id="element-391">
              We may share your personal information and related information
              with external parties if we, in good faith, believe doing so is
              required or appropriate to comply with law enforcement requests,
              national security requests, or other government requests; comply
              with legal process, such as a court order or subpoena; protect
              your, our, or others' rights, property, or safety; enforce our
              policies or contracts; collect amounts owed to us; or assist with
              an investigation or prosecution of suspected or actual
              unauthorized or illegal activity.
            </p>

            <h3 className="text-xl font-bold text-white mt-6" data-id="element-392">
              Disclosure in the Event of Merger, Sale, or Other Asset Transfers
            </h3>

            <p data-id="element-393">
              If we are involved in a merger, acquisition, financing,
              reorganization, bankruptcy, receivership, purchase or sale of
              assets, transition of service to another provider, or other
              similar corporate transaction, your personal information may be
              shared, sold, or transferred as part of such a transaction.
            </p>

            <h2 id="section-5" className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-394">
              5. YOUR PRIVACY CHOICES AND RIGHTS
            </h2>

            <p data-id="element-395">
              <strong data-id="element-396">Your Privacy Choices.</strong> The privacy choices you may
              have about your personal information are described below.
            </p>

            <p data-id="element-397">
              <strong data-id="element-398">Email Communications.</strong> If you receive an unwanted
              email from us, you can use the unsubscribe functionality found at
              the bottom of the email to opt out of receiving future emails.
              Note that you will not be able to opt out of certain
              communications (e.g., communications regarding the Services or
              updates to this Privacy Notice).
            </p>

            <p data-id="element-399">
              <strong data-id="element-400">Mobile Devices.</strong> We may send you push
              notifications through our mobile application. You may opt out of
              receiving these push notifications by changing the settings on
              your mobile device. With your consent, we may also collect precise
              location-based information via our mobile application. You may opt
              out of this collection by changing the settings on your mobile
              device. To request deletion of your account, please use the
              standard deletion functionality available via the Services or
              contact us using the information set forth in "Contact Us" below.
            </p>

            <p data-id="element-401">
              <strong data-id="element-402">"Do Not Track."</strong> Do Not Track ("DNT") is a privacy
              preference that users can set in certain web browsers. Please note
              that we do not respond to or honor DNT signals or similar
              mechanisms transmitted by web browsers.
            </p>

            <p data-id="element-403">
              <strong data-id="element-404">Cookies.</strong> You may stop or restrict the placement
              of Technologies on your device or remove them by adjusting your
              preferences as your browser or device permits. However, if you
              adjust your preferences, the Services may not work properly.
            </p>

            <p data-id="element-405">
              Please note that cookie-based opt-outs are not effective on mobile
              applications. However, you may opt out of certain tracking on some
              mobile applications by following the instructions for Android,
              iOS, and other mobile operating systems.
            </p>

            <p data-id="element-406">
              The online advertising industry also provides mechanisms that may
              allow you to opt out of receiving targeted ads from organizations
              that participate in self-regulatory programs. To learn more, visit
              the Network Advertising Initiative, the Digital Advertising
              Alliance, and the European Digital Advertising Alliance.
            </p>

            <p data-id="element-407">
              Please note you must separately opt out in each browser and on
              each device.
            </p>

            <p data-id="element-408">
              <strong data-id="element-409">Your Privacy Rights.</strong> In accordance with
              applicable law, you may have the right to:
            </p>

            <ul className="list-disc pl-6 space-y-2" data-id="element-410">
              <li data-id="element-411">
                Request Access to or Portability of Your Personal Information;
              </li>
              <li data-id="element-412">Request Correction of Your Personal Information;</li>
              <li data-id="element-413">Request Deletion of Your Personal Information;</li>
              <li data-id="element-414">
                Request Restriction of or Object to Our Processing of Your
                Personal Information; and
              </li>
              <li data-id="element-415">
                Withdraw Your Consent to Our Processing of Your Personal
                Information. Please note that your withdrawal will take effect
                only for future processing and will not affect the lawfulness of
                processing before the withdrawal.
              </li>
            </ul>

            <p data-id="element-416">
              If you would like to exercise any of these rights, please contact
              us as set forth in "Contact Us" below.
            </p>

            <p data-id="element-417">
              We will process such requests in accordance with applicable laws.
            </p>

            <p data-id="element-418">
              If your personal information is subject to the applicable data
              protection laws of the European Economic Area or the United
              Kingdom, you have the right to lodge a complaint with the
              competent supervisory authority if you believe that our processing
              of your personal information violates applicable law.
            </p>

            <h2 id="section-6" className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-419">
              6. INTERNATIONAL TRANSFERS OF PERSONAL INFORMATION
            </h2>

            <p data-id="element-420">
              All personal information processed by us may be transferred,
              processed, and stored anywhere in the world, including, but not
              limited to, the United States or other countries, which may have
              data protection laws that are different from the laws where you
              live. These countries may or may not have adequate data protection
              laws as defined by the data protection authority in your country.
            </p>

            <p data-id="element-421">
              If we transfer personal information from the European Economic
              Area, Switzerland, and/or the United Kingdom to a country that
              does not provide an adequate level of protection under applicable
              data protection laws, one of the safeguards we may use to support
              such transfer is the EU Standard Contractual Clauses.
            </p>

            <p data-id="element-422">
              For more information about the safeguards we use for international
              transfers of your personal information, please contact us as set
              forth below.
            </p>

            <h2 id="section-7" className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-423">
              7. RETENTION OF PERSONAL INFORMATION
            </h2>

            <p data-id="element-424">
              We store the personal information we collect as described in this
              Privacy Notice for as long as you use the Services, or as long as
              necessary to fulfill the purpose(s) for which it was collected, or
              as long as necessary to pursue our business purposes.
            </p>

            <p data-id="element-425">
              To determine the appropriate retention period for personal
              information, we may consider applicable legal requirements; the
              amount, nature, and sensitivity of the personal information;
              certain risk factors; the purposes for which we process your
              personal information; and whether we can achieve those purposes
              through other means.
            </p>

            <h2 id="section-8" className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-426">
              8. SUPPLEMENTAL NOTICE FOR EU/UK GDPR
            </h2>

            <p data-id="element-427">
              This Supplemental Notice for EU/UK GDPR applies only to our
              processing of personal information that is subject to the EU or UK
              General Data Protection Regulation.
            </p>

            <p data-id="element-428">
              In some cases, providing personal information may be a requirement
              under applicable law, a contractual requirement, or a requirement
              necessary to enter into a contract. If you choose not to provide
              personal information in cases where it is required, we will inform
              you of the consequences at the time of your refusal to provide the
              personal information.
            </p>

            <h2 id="section-9" className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-429">
              9. CHILDREN'S PERSONAL INFORMATION
            </h2>

            <p data-id="element-430">
              The Services are not directed to children under 13 (or other age
              as required by local law outside the United States), and we do not
              knowingly collect personal information from children.
            </p>

            <p data-id="element-431">
              If you are a parent or guardian and believe that your child has
              uploaded personal information to the Services in violation of
              applicable law, you may contact us as described in "Contact Us"
              below.
            </p>

            <h2 id="section-10" className="text-2xl font-bold text-white mt-10" style={{
            fontFamily: 'Bungee, sans-serif'
          }} data-id="element-432">
              10. CONTACT US
            </h2>

            <p data-id="element-433">
              Fifth Door is the controller of the personal information we
              process under this Privacy Notice.
            </p>

            <p data-id="element-434">
              If you have any questions about our privacy practices or this
              Privacy Notice, or to exercise your rights as detailed in this
              Privacy Notice, please contact us at:{' '}
              <a href="mailto:accounts@fifthdoor.com" className="text-white underline hover:opacity-80" data-id="element-435">
                accounts@fifthdoor.com
              </a>
              .
            </p>
          </div>
        </div>
      </main>

      <Footer data-id="element-436" />
    </>;
}